$(document).ready(function() {
	//GPC0105.js 참조 스크립트.

	var parent_node = document.querySelector('.select-region');
	if(!parent_node) return false;

	var continent_item = document.querySelectorAll(".continent-item");

	for(var idx = 0; idx < continent_item.length; idx++){
		var days = [];
		// day continentList length check
		// just one
		if( 2 > continent_item.length ){
			$(continent_item).eq(idx).find(".btn-toggle").attr({
				"aria-disabled" : true,
				"disabled" : true
			});
			return false;
		// more than one
		}else{
			days[idx] = new continentList(continent_item[idx]);
			days[idx].init();
		}
	}

	function continentList(element_node){
		var $this = $(element_node);
		var $content = $this.find(".country-contents");
		var p = continentList.prototype;
		p.init = function(){
			p.eventLitsener();
		}
		p.eventLitsener = function(){
			$this.find(".btn-toggle").on("click", function(){
				p.accessibility($(this));
				p.toggleEvent($content);
			});
		}
		p.accessibility = function($target){
			var $elm = $target.closest('.continent-item').find('.country-contents');
			if($elm.css('display') === "block"){
				$target.attr("aria-expanded", "false");
			}else{
				$(".continent-item .btn-toggle").attr("aria-expanded", "false");
				$target.attr("aria-expanded", "true");
			}

			// if($target.attr("aria-expanded") === "true"){
			// 	$target.attr("aria-expanded", "false");
			// }else{
			// 	$(".continent-item .btn-toggle").attr("aria-expanded", "false");
			// 	$target.attr("aria-expanded", "true");
			// }
		}
		p.toggleEvent = function(tg){
			$(".continent-item .country-contents").collapse("hide");
			tg.collapse("toggle");
		}
	}
});
